import styled from 'styled-components'

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-columns: repeat(1, 1fr);
  gap: 24px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 1268px) {
    grid-template-columns: repeat(3, 1fr);
  }

  > div {
    min-width: 0;
  }
`

export const Container = styled.section``
